export const isLoadingEspecialidadesAll = state => (state.schedule.especialidadesAll.isLoading)
export const especialidadesAll = state => (state.schedule.especialidadesAll.data)

export const isLoadingEspecialidades = state => (state.schedule.especialidades.isLoading)
export const especialidades = state => (state.schedule.especialidades.data)

export const isLoadingEnderecos = state => (state.schedule.enderecos.isLoading)
export const enderecos = state => (state.schedule.enderecos.data)

export const isLoadingSearch = state => (state.schedule.search.isLoading)
export const search = state => (state.schedule.search.data)
export const searchTipo = state => (state.schedule.search.tipo)
export const searchReceivedAt = state => (state.schedule.search.receivedAt)

export const isLoadingMedico = state => (state.schedule.medico.isLoading)
export const medico = state => (state.schedule.medico.data)
export const errorMedico = state => (state.schedule.medico.error)

export const isLoadingMedicoCalendar = state => (state.schedule.medicoCalendar.isLoading)
export const medicoCalendar = state => (state.schedule.medicoCalendar.data)
export const errorMedicoCalendar = state => (state.schedule.medicoCalendar.error)

export const isLoadingMedicoRatings = state => (state.schedule.medicoRatings.isLoading)
export const medicoRatings = state => (state.schedule.medicoRatings.data)
export const errorMedicoRatings = state => (state.schedule.medicoRatings.error)

export const isLoadingPlantao = state => (state.schedule.plantao.isLoading)
export const plantao = state => (state.schedule.plantao.data)

export const isLoadingPlantaoFila = state => (state.schedule.plantaoFila.isLoading)
export const plantaoFila = state => (state.schedule.plantaoFila.data)
export const errorPlantaoFila = state => (state.schedule.plantaoFila.error)

export const isLoadingPlantaoUnicoPrice = state => (state.schedule.plantaoUnicoPrice.isLoading)
export const plantaoUnicoPrice = state => (state.schedule.plantaoUnicoPrice.data)
export const plantaoUnicoPriceError = state => (state.schedule.plantaoUnicoPrice.error)

export const isLoadingSavePlantaoUnico = state => (state.schedule.savePlantaoUnico.isLoading)

export const isLoadingRating = state => (state.schedule.rating.isLoading)
export const rating = state => (state.schedule.rating.data)

export const isLoadingSaveRating = state => (state.schedule.saveRating.isLoading)

export const isLoadingAtendimento = state => (state.schedule.atendimento.isLoading)
export const atendimento = state => (state.schedule.atendimento.data)

export const isLoadingCreateAtendimento = state => (state.schedule.createAtendimento.isLoading)
export const createAtendimentoError = state => (state.schedule.createAtendimento.error)

export const isLoadingJoinQueue = state => (state.schedule.joinQueue.isLoading)
export const joinQueueError = state => (state.schedule.joinQueue.error)

export const isLoadingLeaveQueue = state => (state.schedule.leaveQueue.isLoading)
export const leaveQueueError = state => (state.schedule.leaveQueue.error)

export const isLoadingCancel = state => (state.schedule.scheduleCancel.isLoading)
export const errorCancel = state => (state.schedule.scheduleCancel.error)
export const successCancel = state => (state.schedule.scheduleCancel.success)

export const isLoadingReschedule = state => (state.schedule.reschedule.isLoading)
export const errorReschedule = state => (state.schedule.reschedule.error)
export const successReschedule = state => (state.schedule.reschedule.success)

export const isLoadingScheduleReturn = state => (state.schedule.scheduleReturn.isLoading)
export const errorScheduleReturn = state => (state.schedule.scheduleReturn.error)
export const successScheduleReturn = state => (state.schedule.scheduleReturn.success)

export const isLoadingMedicalRecords = state => (state.schedule.medialRecords.isLoading)
export const medialRecords = state => (state.schedule.medialRecords.data)
export const errorMedicalRecords = state => (state.schedule.medialRecords.error)

export const isLoadingInvoiceRequest = state => (state.schedule.invoiceRequest.isLoading)

export const isLoadingConfirmPresence = state => (state.schedule.confirmPresence.isLoading)

export const isLoadingCabin = state => (state.schedule.cabin.isLoading)
export const cabin = state => (state.schedule.cabin.data)
export const errorCabin = state => (state.schedule.cabins.error)
